import { render, staticRenderFns } from "./RolesTableItem.vue?vue&type=template&id=b9e593ea&scoped=true"
import script from "./RolesTableItem.vue?vue&type=script&lang=js"
export * from "./RolesTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e593ea",
  null
  
)

export default component.exports